import { Record } from 'immutable';

type AssetDetailsList = {
  thirdPartyName: string;
  thirdPartyPropertyID: string;
  value: number;
  useCode: string;
  bedrooms: string;
  bathrooms?: string;
  propertySqFt: number;
  areaSquareFeet: string;
  noOfUnits: number;
  totalRooms: number;
  totalStories: number;
  yearBuilt: number;
  numberOfBuildings: number;
  ownerName: string;
  zestimateTime: string;
  rentalZestimate: number;
  rentalTimestamp: string;
  detailsURL: string;
};

export type HousingSelectionType = {
  id?: string;
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  assetDetailsList?: Array<AssetDetailsList>;
  isDeleted?: false;
  full?: string;
  bedrooms?: string;
  bathrooms?: string;
  areaSquareFeet?: string;
};

export const mkHousing = Record<HousingSelectionType>({
  id: undefined,
  line1: undefined,
  city: undefined,
  state: undefined,
  zipCode: undefined,
  assetDetailsList: undefined,
  isDeleted: false,
  line2: undefined,
  bedrooms: undefined,
  bathrooms: undefined,
  full: undefined,
  areaSquareFeet: undefined,
});
